import ProductCategoryListResultModelBase from '../_generated/modelBases/product-category-list-result-model-base';

export default class ProductCategoryListResultModel extends ProductCategoryListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
